import React, {useState} from 'react';
import {Button, Col, Container, Dropdown, Row} from 'react-bootstrap';
import {AppNavbar} from '../components/AppNavbar';
import {PLAN, PRUBEH, SKUTECNOST, SOUHRN, STATISTIKA, STROM} from '../enums/PohledTypeEnum';
import {SouhrnPanel} from '../components/SouhrnPanel';
import {RouteComponentProps, useHistory} from 'react-router';
import {baseURL, EnumPlanObdobi, SouhrnApi} from '../api';
import {Footer} from '../components/Footer';
import {SouhrnControllerApiAxiosParamCreator} from '../api/api/souhrn-controller-api';

type Props = RouteComponentProps<{idVerze: string}, {}>;
export const SouhrnPage: React.FC<Props> = ({match: {params}}) => {
    const history = useHistory();

    const [pohledType, setPohledType] = useState(PLAN);

    const exportS = () => {
        const exportSouhrn = async () => {
            let id: string = '';
            try {
                let obdobiEnum;
                if (pohledType === SKUTECNOST) {
                    obdobiEnum = EnumPlanObdobi.SKUTECNOST;
                } else if (pohledType === PLAN) {
                    obdobiEnum = EnumPlanObdobi.PLAN;
                } else {
                    obdobiEnum = EnumPlanObdobi.PRUBEH;
                }
                id = (await SouhrnApi.exportSouhrn(parseInt(params.idVerze), obdobiEnum)).data;
                const url = baseURL + (await SouhrnControllerApiAxiosParamCreator().downloadSouhrnExportFile(id)).url;
                window.open(url);
            } catch (error) {
                // TODO
            }
        };
        exportSouhrn();
    };

    return (
        <div className="main-div">
            <header>
                <AppNavbar page={'souhrn'} idVerze={params.idVerze} planObdobi={pohledType} />
            </header>
            <main>
                <Container fluid>
                    <Row xs="auto" style={{paddingTop: 10, paddingBottom: 10, height: '100%'}}>
                        <Col>
                            <Dropdown>
                                <Dropdown.Toggle variant="light" id="dropdown-basic">
                                    {SOUHRN}
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Dropdown.Item>{SOUHRN}</Dropdown.Item>
                                    <Dropdown.Item onClick={() => history.push('/strom/' + params.idVerze)}>{STROM}</Dropdown.Item>
                                    <Dropdown.Item onClick={() => history.push('/statistika/' + params.idVerze)}>{STATISTIKA}</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Col>
                        <Col>
                            <Dropdown>
                                <Dropdown.Toggle variant="light" id="dropdown-basic">
                                    {pohledType}
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={() => setPohledType(PLAN)}>{PLAN}</Dropdown.Item>
                                    <Dropdown.Item onClick={() => setPohledType(SKUTECNOST)}>{SKUTECNOST}</Dropdown.Item>
                                    <Dropdown.Item onClick={() => setPohledType(PRUBEH)}>{PRUBEH}</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Col>
                        <Col className="class-col">
                            <Button variant="light" onClick={() => exportS()}>
                                Export
                            </Button>
                        </Col>
                    </Row>
                    <Row>{params.idVerze && <SouhrnPanel planObdobi={pohledType} idVerze={params.idVerze} />}</Row>
                </Container>
            </main>
            <footer>
                <Footer idPlanVerze={params.idVerze} />
            </footer>
        </div>
    );
};
